import React, { useState, useRef, useEffect } from 'react';
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from '@xyflow/react';
import { Delete16Regular } from '@fluentui/react-icons';
import './CSS/CustomEdge.css';

/**
 * Edge avec label DTMF éditable inline et bouton delete
 * Utilise des lignes avec coins arrondis (smoothstep)
 */
const EditableDTMFEdge = ({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  label,
  labelStyle,
  labelBgStyle,
  data,
  selected,
}) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(label || '');
  const inputRef = useRef(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  useEffect(() => {
    setEditValue(label || '');
  }, [label]);

  const handleDoubleClick = (e) => {
    e.stopPropagation();
    setEditValue(label || '');
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    if (editValue !== label && data?.onLabelChange && editValue.trim()) {
      data.onLabelChange(id, editValue.trim(), source, target, label);
    } else {
      setEditValue(label || '');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.target.blur();
    } else if (e.key === 'Escape') {
      setEditValue(label || '');
      setIsEditing(false);
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (data?.onDelete) {
      data.onDelete(id);
    }
  };

  return (
    <>
      <BaseEdge 
        path={edgePath} 
        markerEnd={markerEnd} 
        style={{
          ...style,
          strokeWidth: selected ? 3 : 2,
        }} 
      />
      <EdgeLabelRenderer>
        <div
          className="custom-edge-label-wrapper"
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
          }}
        >
          {isEditing ? (
            <input
              ref={inputRef}
              type="text"
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              onBlur={handleBlur}
              onKeyDown={handleKeyDown}
              className="editable-edge-input"
              onClick={(e) => e.stopPropagation()}
              placeholder={data?.inputPlaceholder || 'DTMF'}
            />
          ) : (
            <div
              className="custom-edge-label"
              onDoubleClick={handleDoubleClick}
              title="Double-cliquer pour éditer"
            >
              {label || '?'}
            </div>
          )}
          
          {/* Bouton delete visible au hover ou quand sélectionné */}
          {!isEditing && (
            <button
              className="custom-edge-delete-btn"
              onClick={handleDelete}
              title="Supprimer la connexion"
            >
              <Delete16Regular />
            </button>
          )}
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default EditableDTMFEdge;
